export default "__VITE_ASSET__Dxj5j18O__"